import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFieldComponent } from './form-field.component';
import { FormInputDirective } from './input.directive';
import { TranslateModule } from '@ngx-translate/core';
import { NzFormModule } from 'ng-zorro-antd/form';

@NgModule({
  declarations: [FormFieldComponent, FormInputDirective],
  imports: [CommonModule, TranslateModule, NzFormModule],
  exports: [FormFieldComponent, FormInputDirective],
})
export class FormFieldModule {}
